// @ts-nocheck
import React, { Component } from 'react';
import { navigate } from '../../../../lib/routerAdapter';
import { Tabs, TabItem } from '../../../../components/ui';
export default class HeaderTabs extends Component {
  render() {
    return <Tabs defaultTab={this.props.selectedTab}>
        <TabItem tabKey="training" label="Обучение" onClick={() => navigate(`/pdd/results/training/`)} />
        <TabItem tabKey="exam" label="Экзамен" onClick={() => navigate(`/pdd/results/exam/`)} />
      </Tabs>;
  }
}
